import { render, staticRenderFns } from "./AiHotList.vue?vue&type=template&id=8e977c58&scoped=true"
import script from "./AiHotList.vue?vue&type=script&lang=js"
export * from "./AiHotList.vue?vue&type=script&lang=js"
import style0 from "./AiHotList.vue?vue&type=style&index=0&id=8e977c58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e977c58",
  null
  
)

export default component.exports